// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M3.5 7C3.5 4.23858 5.73858 2 8.5 2C11.2614 2 13.5 4.23858 13.5 7C13.5 9.76142 11.2614 12 8.5 12C5.73858 12 3.5 9.76142 3.5 7ZM23.5962 8.43934L17.9393 14.0962L14.4038 10.5607L15.818 9.14645L17.9393 11.2678L22.182 7.02513L23.5962 8.43934ZM0 19C0 16.2386 2.23858 14 5 14H12C14.7614 14 17 16.2386 17 19V21C9.77818 21 3.91154 21 0 21V19Z"}}]};

const UserChecked1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'user-checked-1-filled',
    ref,
    icon: element,
  },
));

UserChecked1FilledIcon.displayName = 'UserChecked1FilledIcon';

export default UserChecked1FilledIcon;
